<div class="field">
	<label *ngIf="label" [for]="inputId">{{ label }}</label>
	<p-inputNumber
		#counterInput
		buttonLayout="horizontal"
		decrementButtonIcon="fa-solid fa-minus"
		incrementButtonIcon="fa-solid fa-plus"
		mode="decimal"
		mode="decimal"
		spinnerMode="horizontal"
		[allowEmpty]="false"
		[class.full__width]="fullWidth"
		[decrementButtonClass]="buttonStyleString"
		[disabled]="disabled"
		[incrementButtonClass]="buttonStyleString"
		[inputStyleClass]="inputStyleString"
		[max]="max"
		[maxFractionDigits]="parameters.stockDecimalPlaces || 0"
		[min]="min"
		[minFractionDigits]="parameters.stockDecimalPlaces || 0"
		[showButtons]="true"
		[step]="step"
		[(ngModel)]="value"
		(onBlur)="onChangeValue(counterInput.value)"
		(onInput)="onChangeValue($event.value)"
	></p-inputNumber>
</div>
